var map = {
	"./bake-rolls.svg": "22e3",
	"./mix-instruction.svg": "888c",
	"./proof-dough.svg": "17e3",
	"./roll-dough-top-down.svg": "5a3f",
	"./roll-dough.svg": "0cb5",
	"./spiral-dough-top-down.svg": "f639",
	"./spiral-dough.svg": "9605"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";